import styled from '@emotion/styled';
import { Css, ITheme, StyledAccordionTitle, UnstyledUl } from '@/ui';
import { Color } from '../../../../styles/Color';
import { Shadow } from '../../../../styles/Shadow';
import { Z_INDEX_NAVIGATION_MENU } from '../../../../styles/zIndex';
import { NavigationItemFont } from '../Navigation.styles';
import { Accordion, AccordionItem } from '../../accordion';
import { RouterLink } from '../../link/RouterLink';

const MOBILE_MENU_MARGIN = Css.pxToRem(16);

export const Wrapper = styled('div')<{ isSticky: boolean }>`
	padding-top: ${Css.pxToRem(16)};
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: ${Css.pxToRem(16)};

	&[aria-hidden='true'] {
		display: none;
	}
`;

export const ToggleButton = styled.button<{ hidden?: boolean }, ITheme>`
	pointer-events: all;
	display: ${({ hidden }) => (hidden ? 'hidden' : 'block')};
	float: right;
	border-radius: ${Css.pxToRem(54)};
	background: ${Color.PrimaryWhite};
	box-shadow: ${Shadow.Small};
	border: none;
	padding: ${Css.pxToRem(8)} ${MOBILE_MENU_MARGIN};
	${({ theme }) => NavigationItemFont(theme)};
	color: ${({ theme }) => theme.color.brand};
	z-index: ${Z_INDEX_NAVIGATION_MENU};

	&:active {
		background-color: ${Color.Neutral94};
	}
`;

export const MobileMenu = styled.div<{ open: boolean }>`
	min-height: 100vh;
	overflow-y: auto;
	pointer-events: all;

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: ${Color.PrimaryWhite};
	z-index: ${Z_INDEX_NAVIGATION_MENU};

	opacity: ${({ open }) => (open ? 1 : 0)};
	visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
	transform: ${({ open }) => (open ? `scale(1)` : `scale(0.95)`)};
	pointer-events: ${({ open }) => (open ? 'all' : 'none')};
	transition: opacity 0.3s, transform 0.3s;
`;

export const StyledLink = styled(RouterLink)<{}, ITheme>`
	text-decoration: none;
	color: ${Color.OnBackgroundText};

	&:active {
		color: ${({ theme }) => theme.color.brand};
	}
`;

export const MobileHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: ${MOBILE_MENU_MARGIN};
	padding-bottom: 0;
`;

export const MobileHeaderTitle = styled.h4<{}, ITheme>`
	text-transform: uppercase;
	color: ${({ theme }) => theme.color.brand};
	line-height: normal;
`;

export const CloseButton = styled('button')<{}, ITheme>`
	position: fixed;
	top: ${Css.pxToRem(16)};
	right: ${Css.pxToRem(16)};
	float: right;
	border-radius: ${Css.pxToRem(54)};
	background: ${Color.PrimaryWhite};
	box-shadow: ${Shadow.ExtraSmall};
	border: none;
	padding: ${Css.pxToRem(8)};
	${({ theme }) => NavigationItemFont(theme)};
	color: ${({ theme }) => theme.color.brand};

	svg {
		path {
			fill: currentColor;
		}
	}
`;

export const StyledAccordion = styled(Accordion)`
	padding-top: 0;
`;

export const StyledAccordionItem = styled(AccordionItem)<{}, ITheme>`
	border-bottom: 1px solid ${Color.Neutral94};

	${StyledAccordionTitle} {
		padding: ${MOBILE_MENU_MARGIN};
		border-color: ${Color.Neutral94};
		border-bottom: 1px solid ${Color.Neutral94};
	}

	a {
		text-decoration: none;
		color: ${Color.OnBackgroundText};
		margin: 0 ${Css.pxToRem(16)};

		&:active {
			color: ${({ theme }) => theme.color.brand};
		}
	}
`;

export const SiteSectionScrollWrap = styled.div`
	overflow-x: auto;
	white-space: nowrap;
`;

export const SiteSectionList = styled(UnstyledUl)`
	display: inline-flex;
	flex-direction: row;
	gap: ${Css.pxToRem(8)};
	margin-top: ${Css.pxToRem(32)};
	margin-bottom: ${Css.pxToRem(40)};
`;

export const List = styled.ul`
	display: flex;
	gap: ${Css.pxToRem(8)};
	margin: 0;
	padding: ${MOBILE_MENU_MARGIN};
	list-style: none;
`;
